var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCareHistory(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2187_42679)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 6.07031,
    y: 6.15625,
    width: 29.208,
    height: 29.208,
    rx: 14.604,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6.07031,
    y: 6.15625,
    width: 29.208,
    height: 29.208,
    rx: 14.604,
    fill: "url(#paint0_radial_2187_42679)",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6.07031,
    y: 6.15625,
    width: 29.208,
    height: 29.208,
    rx: 14.604,
    fill: "url(#paint1_radial_2187_42679)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 5.37488,
    y: 5.46082,
    width: 30.5989,
    height: 30.5989,
    rx: 15.2994,
    stroke: "white",
    strokeWidth: 1.39086
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2187_42679)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.8067 23.876H20.5459C20.0426 23.876 19.6332 23.4666 19.6332 22.9633V21.7898H18.4596C17.9563 21.7898 17.5469 21.3803 17.5469 20.877V20.6162C17.5469 20.1129 17.9563 19.7035 18.4596 19.7035H19.6332V18.5299C19.6332 18.0266 20.0426 17.6172 20.5459 17.6172H20.8067C21.31 17.6172 21.7194 18.0266 21.7194 18.5299V19.7035H22.893C23.3963 19.7035 23.8057 20.1129 23.8057 20.6162V20.877C23.8057 21.3803 23.3963 21.7898 22.893 21.7898H21.7194V22.9633C21.7194 23.4666 21.31 23.876 20.8067 23.876Z",
    fill: "#516CD3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.5562 20.7594C26.453 20.7539 26.3518 20.7889 26.274 20.857C26.1963 20.9252 26.1482 21.0209 26.14 21.124C25.9491 23.99 23.5473 26.2354 20.6729 26.2354C17.653 26.2354 15.1964 23.7788 15.1964 20.7589C15.1964 17.739 17.653 15.2824 20.6729 15.2824C22.0139 15.2824 23.2714 15.7674 24.2525 16.6259L23.9171 16.9618C23.8625 17.0165 23.8253 17.0862 23.8102 17.162C23.7951 17.2379 23.8029 17.3165 23.8325 17.3879C23.862 17.4593 23.9121 17.5204 23.9764 17.5634C24.0406 17.6064 24.1162 17.6294 24.1935 17.6294H25.4975C25.6012 17.6294 25.7007 17.5882 25.7741 17.5149C25.8474 17.4415 25.8886 17.342 25.8886 17.2383V15.9343C25.8886 15.5885 25.4688 15.4107 25.221 15.6579L24.8059 16.0731C23.6692 15.0573 22.1974 14.4971 20.6729 14.5C17.2217 14.5 14.4141 17.3076 14.4141 20.7589C14.4141 24.2101 17.2217 27.0177 20.6729 27.0177C23.9583 27.0177 26.7028 24.4516 26.9208 21.1761C26.9277 21.0725 26.8932 20.9704 26.8248 20.8923C26.7564 20.8142 26.6598 20.7664 26.5562 20.7594Z",
    fill: "#516CD3"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2187_42679",
    x: 0.507115,
    y: 0.593052,
    width: 40.3373,
    height: 40.3373,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.08629
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.2 0 0 0 0 0.2 0 0 0 0 0.2 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2187_42679"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2187_42679",
    result: "shape"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_2187_42679",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(13.778 12.2413) rotate(51.0441) scale(24.5185 24.5185)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.59
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6875,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_2187_42679",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(31.2772 31.7133) rotate(-93.6705) scale(24.9998 27.8633)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#516CD3",
    stopOpacity: 0.34
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#516CD3",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.861815,
    stopColor: "#516CD3",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2187_42679"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12.5177,
    height: 12.5177,
    fill: "white",
    transform: "translate(14.4141 14.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCareHistory);
export default __webpack_public_path__ + "static/media/CareHistory.e5872dd62946c62b89a0fee4348f08ff.svg";
export { ForwardRef as ReactComponent };